import type { KyInstance } from "ky";

export interface TrophyCaseResponse {
    challengesHistory: {
        badge: string;
        challengeName: string;
        challengeType: "solo" | "team" | "quiz";
        startDate: Date;
    }[];
    trophyCaseStats: {
        challengeType: string;
        totalCount: number;
        successfulCount: number;
    }[];
    pagination?: {
        offset: number;
        limit: number;
        hasMore: boolean;
        nextOffset: number | null;
    };
}

export const getTrophyCaseData = async (client: KyInstance) => {
    const response = await client.get("v1/metrics/challenges-history");
    const data = await response.json<TrophyCaseResponse>();
    return data;
};
